import React from 'react'
import { Form, FormRow, Input, Button } from '../common/Form'

class AddArtistForm extends React.Component {
    state = {
        name: ''
    }

    onChange = e => {
        this.setState({ name: e.target.value })
    }

    onSubmit = e => {
        e.preventDefault()

        this.props.artistsActions.add(this.state)
        this.setState({ name: '' })
    }

    render() {
        return (
            <Form onSubmit={this.onSubmit}>
                <FormRow>
                    <Input onChange={this.onChange} value={this.state.name} />
                </FormRow>
                <FormRow>
                    <Button label="Adauga Artist" />
                </FormRow>
            </Form>
        )
    }
}

export default AddArtistForm


// WEBPACK FOOTER //
// ./src/components/artists/AddArtistForm.js